import React from 'react';
import LabNav from '../../components/lab/LabNav';
import LabHero from '../../components/lab/LabHero';
import Constellation from '../../components/lab/Constellation';
import ProductIndex from '../../components/lab/ProductIndex';
import Statement from '../../components/lab/Statement';
import TheLab from '../../components/lab/TheLab';
import EvolveLoop from '../../components/lab/EvolveLoop';
import Stack from '../../components/lab/Stack';
import WhyEvolve from '../../components/lab/WhyEvolve';
import LabFooter from '../../components/lab/LabFooter';

const Home = () => (
    <>
        <LabNav />

        <main>
            <LabHero />

            {/* The ecosystem, before the detail */}
            <Constellation />

            {/* Loud */}
            <Statement
                lines={['Ideas become', { text: 'products here.', accent: true }]}
                note="Evolve Labs designs, builds, launches, and operates its own software. The products are the proof."
            />

            {/* The index */}
            <ProductIndex />

            {/* Loud */}
            <Statement
                lines={[
                    "We don't build",
                    'software for clients.',
                    { text: 'We build software', accent: true },
                    { text: 'we believe should exist.', accent: true },
                ]}
                size="md"
            />

            <TheLab />

            <EvolveLoop />

            <Stack />

            <WhyEvolve />

            {/* Final brand moment before the footer */}
            <Statement
                lines={['Build.', 'Ship.', 'Learn.', { text: 'Evolve.', accent: true }]}
                align="center"
                size="lg"
            />
        </main>

        <LabFooter />
    </>
);

export default Home;
